module.exports = __webpack_public_path__ + "static/media/helena-win.b663d44d.png";